<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h500_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item
                    label="活动名称"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.activityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="省区"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="类型"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.sortStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="兑换名称"
                    prop="name"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.name"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="开始日期"
                    prop="startDate"
                  >
                    <el-date-picker
                      v-model="dialogAddEditViewForm.startDate"
                      disabled
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="结束日期"
                    prop="endDate"
                  >
                    <el-date-picker
                      v-model="dialogAddEditViewForm.endDate"
                      disabled
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col
                  v-if="dialogAddEditViewForm.sort === 1"
                  :span="6"
                >
                  <el-form-item
                    label="兑换积分"
                    prop="integral"
                  >
                    <el-input
                      v-model.number="dialogAddEditViewForm.integral"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogAddEditViewForm.sort === 2"
                  :span="6"
                >
                  <el-form-item
                    label="中奖率(例10%，请输入0.1)"
                    prop="winRate"
                  >
                    <el-input
                      v-model.number="dialogAddEditViewForm.winRate"
                      @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'winRate')}"
                      @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'winRate', 4);"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    :label="dialogAddEditViewForm.sort === 1 ? '兑换数量' : '中奖总数量'"
                    prop="amount"
                  >
                    <el-input
                      v-model.number="dialogAddEditViewForm.amount"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 数据请求
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'

import { initAppConsumerIntegralExchangeSettingApi, saveOrUpdateAppConsumerIntegralExchangeSettingApi } from '@/api/appConsumerIntegralExchangeSetting'
export default {
  components: { },
  mixins: [dialogDragMixin,setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {
      },
      dialogAddEditViewFormRules: {
        integral: [ { type: 'number', required: true, message: '积分必须为数字值', trigger: 'blur' }],
        winRate: [ { required: true, message: '请输入中奖率', trigger: 'blur' }],
        amount: [ { type: 'number', required: true, message: '数量必须为数字值', trigger: 'blur' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' } ]
      },
      provinceOptions: [],
      dialogActivityVisible: false
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.dialogAddEditViewForm = {
          activityName: '',
          provinceName: '',
          provinceId: '',
          name: '',
          startDate: '',
          endDate: '',
          sort: 1,
          sortStr: '',
          integral: '',
          winRate: 0,
          amount: '',
          leftAmount: 0,
          status: 1,
          remark: ''
        }
        this.provinceOptions = []
        this.initConsumerIntegralExchangeSettingData()
      }
    }
  },
  methods: {
    // 加载数据
    initConsumerIntegralExchangeSettingData () {
      initAppConsumerIntegralExchangeSettingApi({ id: this.dataId }).then(res => {
        const { data } = res
        for(let key in this.dialogAddEditViewForm){
          if(key !== 'startDate' && key !== 'endDate'){
            this.dialogAddEditViewForm[key] = data[key]
          }
        }
        this.dialogAddEditViewForm.startDate = data.startDateStr
        this.dialogAddEditViewForm.endDate = data.endDateStr
        
        this.dialogAddEditViewForm.id = data.id
        this.loading = false
      })
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            '是否确定调整奖品设置','系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText:'取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              this.dialogAddEditViewForm.isAdjust = 1
              this.handlerSave()
            })
            .catch(() => { })
        }
      })
    },
    // 保存
    handlerSave () {
      saveOrUpdateAppConsumerIntegralExchangeSettingApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    },
  }
}
</script>
<style lang="scss"  scoped>

</style>
